import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Truck } from "lucide-react";
import { Reveal } from "./Reveal";

const CARDS = [
  { label: "Local & Interstate Removalists", value: "108+ Partners" },
  { label: "Moves Completed", value: "4,568+" },
  { label: "Avg. Cost (Metro Moves)", value: "$400" },
  { label: "Avg. Response Time", value: "3 hr" },
];

export const MelbourneStats = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden border-b border-slate-200 bg-white/75" data-testid="melbourne-stats-section">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-cover bg-center opacity-[0.08]"
        style={{ backgroundImage: "url(/images/melbourne-skyline.png)" }}
        aria-hidden="true"
      />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-gradient-to-b from-transparent to-white" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-5 py-24 lg:px-10 lg:py-32">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="font-display text-3xl font-semibold uppercase tracking-tighter text-slate-900 sm:text-4xl lg:text-5xl" data-testid="stats-heading">
              Melbourne Removalists <span className="text-blaze">From $69/hr</span>
            </h2>
            <p className="mt-6 text-base font-bold text-slate-900 md:text-lg" data-testid="stats-subheading">
              Why Choose MoversNearby for Your Move?
            </p>
            <p className="mt-3 text-base leading-relaxed text-slate-600">
              We are your dedicated team for local moves across Melbourne and interstate moves Australia-wide.
              With extensive experience making moving smooth, we help people like you settle into new homes
              and local businesses start fresh. Trusted by thousands, we reduce the stress of your move
              with reliability and affordability.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((c, i) => (
            <Reveal key={c.label} delay={i * 0.08}>
              <div
                className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm transition-shadow duration-300 hover:shadow-md"
                data-testid={`stat-card-${i}`}
              >
                <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-slate-500">{c.label}</p>
                <p className="mt-3 font-display text-4xl font-semibold tracking-tight text-slate-900 lg:text-5xl">{c.value}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-12 flex justify-center">
            <button
              onClick={() => navigate("/#quote")}
              className="group flex items-center gap-3 rounded-lg bg-red-600 px-9 py-4 text-sm font-bold uppercase tracking-wider text-white transition-all duration-300 hover:scale-[1.04] hover:bg-red-700 hover:shadow-[0_12px_40px_rgba(220,38,38,0.35)]"
              data-testid="stats-quote-btn"
            >
              Get a Free Quote
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mx-auto mt-14 max-w-3xl">
            <div className="flex flex-col items-center gap-6 rounded-2xl border border-sky-100 bg-sky-50/80 p-8 text-center shadow-sm sm:flex-row sm:text-left" data-testid="success-callout">
              <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white shadow-sm">
                <Truck className="h-8 w-8 text-blue-600" strokeWidth={1.8} />
              </span>
              <div>
                <p className="font-display text-xl font-semibold text-slate-900">4,568+ Successful Moves across Australia.</p>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                  From Melbourne to Sydney, Brisbane to Adelaide — and every suburb in between — we&rsquo;ve
                  helped thousands of families and businesses move homes and offices without a glitch.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
